import { Trans } from '@lingui/macro';
import { useFeatureFlags } from 'api/useFeatureFlags';
import { Button } from 'components/common/Button';

const hoodieMaxCount = 2;
const stickerMaxCount = 20;
const defaultMaxCount = 8;
const framedPrintsSaleCount = 2;

const getMaxCount = (itemType, itemSize, maxStock, framedPrints) => {
  let max;
  if (itemType === 'hoodie' || itemType === 'sweater') {
    max = hoodieMaxCount;
  } else if (itemSize === 'STK') {
    max = stickerMaxCount;
  } else if (itemType === 'print' && framedPrints) {
    max = framedPrintsSaleCount;
  } else {
    max = defaultMaxCount;
  }

  // maxStock <= 0 should be only on homepage for daily & last chance tees
  // variants, which are out of stock, are filtered out otherwise on other pages
  return !maxStock || maxStock < 0 ? max : Math.min(maxStock, max);
};

export const BuyDialogQuantitySelector = ({
  shoppingItem,
  stock,
  onChange,
}) => {
  const { data: featureFlags } = useFeatureFlags();

  const maxStockCount = getMaxCount(
    shoppingItem.type,
    shoppingItem.size,
    stock,
    featureFlags.framedPrints
  );

  return (
    <div className="text-center flex flex-col items-center">
      <p className="font-extrabold text-lg md:text-3xl uppercase text-black leading-6 md:leading-10">
        <Trans>How many would you like?</Trans>
      </p>
      <select
        className="block border-solid border-2 border-black rounded-md h-7 w-14 md:w-24 md:h-10 text-lg md:text-3xl font-serif"
        value={shoppingItem.qty}
        onChange={(event) => onChange(event.currentTarget.value)}
      >
        {maxStockCount > 1 ? (
          [...Array(maxStockCount).keys()].map((index) => (
            <option key={index} value={(index + 1).toString()}>
              {index + 1}
            </option>
          ))
        ) : (
          <option value="1">1</option>
        )}
      </select>
      <Button
        type="submit"
        variant="black"
        size="lg"
        className="py-1.5 md:py-2.5 !px-3.5 md:!px-6 !rounded-lg md:!rounded-xl mt-3 md:mt-5 !text-sm md:!text-2xl"
      >
        <Trans>ADD TO CART</Trans>
      </Button>
    </div>
  );
};
